import React from 'react';
import { connect } from 'react-redux';
import { Select } from '@nerdwallet/currency';

import { HOME_AFFORDABILITY } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import { inputsSelector } from '../../../lib/selectors/home-affordability-calculator-selectors';
import { HomeAffordabilityInput, inputOnChange } from '../../../lib/utils';
import {
  VETERAN_TYPE_MILITARY_OPTION,
  VETERAN_TYPE_NATIONAL_GUARD_OPTION,
  veteranOptions as VeteranDropdownOptions,
} from '../hacControlOptions';
import { debouncedTrackInputEvent } from '../../../lib/analytics/trackers';
import useAnalytics from '../../../lib/analytics/use-analytics';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

export const getAnalyticValue = (value: string): string => {
  switch (value) {
    case VETERAN_TYPE_MILITARY_OPTION.value:
      return 'yes_regular';
    case VETERAN_TYPE_NATIONAL_GUARD_OPTION.value:
      return 'yes_national_guard';
    default:
      return 'no';
  }
};

const VeteranEligibilityInput: React.FC<HomeAffordabilityInput> = ({
  inputs,
  dispatch,
  analytics,
  validations,
  label = '',
  className = '',
  tooltip = '',
  fullWidth,
}) => {
  const segmentAbstract = useAnalytics();
  const value = inputs?.veteranType;
  const errorMessage = validations?.veteranType?.[0];
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_s',
      };
    }

    // segment analytics
    debouncedTrackInputEvent(
      {
        field_value: e.target.value || 'No',
        field_type: 'drop-down',
        entityName: 'are_you_a_veteran',
        field: 'Are you a veteran',
      },
      segmentAbstract
    );

    inputOnChange({
      event: e,
      dispatch,
      bedrock,
      fieldName: 'veteranType',
      calculator: HOME_AFFORDABILITY,
      analyticValue: getAnalyticValue(e?.target?.value),
    });
  };

  return (
    <Select
      options={VeteranDropdownOptions}
      value={value}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      label={label}
      className={className}
      tooltip={tooltip}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state) => ({
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(VeteranEligibilityInput);
